import React from 'react';
import WeddingGrid from '../components/WeddingGrid';
import { ImageHeader } from '../components/ImageHeader';
import weddingParty from 'url:../assets/wedding-party-2.jpg';

const WeddingParty: React.FC = () => {
  const imageUrl = weddingParty;
  const headerContent = <h1>The Wedding Party</h1>;

  return (
    <>
      <ImageHeader headerContent={headerContent} imageUrl={imageUrl} />
      <main>
        <section className="block-content">
          <WeddingGrid />
        </section>
      </main>
    </>
  );
};

export default WeddingParty;
